import React from "react";
import SmartImage from "../SmartImage";
import { EachBlog, EachPopularCourse, PopularCourseContent } from "./style";
import {
  BoldHeadingPri,
  BoldLg,
  BoldSm,
  HorizontalAlign,
  RegSm,
  RegSmPri,
  SpaceBetween,
  VerticalLeftAlign,
  VerticalSpaceBetween,
} from "../CustomStyles";
import Colors from "../../Constant/Colors";
import dayjs from "dayjs";
import images from "../../Constant/images";

const NewsComponent = ({
  news,
  heading,
  isNewsPage,
  handleBlog,
  handleDownloadNews,
}) => {
  const styles = {
    eachNews: {
      width: "50%",
      height: "100%",
      alignSelf: "center",
    },
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 8,
    },
  };
  return (
    <PopularCourseContent>
      <BoldHeadingPri>{heading ?? "News"}</BoldHeadingPri>
      {news.length ? (
        news.map((each) => (
          <EachPopularCourse key={each.id}>
            <div style={styles.eachNews} onClick={() => handleBlog(each)}>
              <SmartImage
                src={each?.image ? each?.image : images?.res1}
                style={styles.img}
              />
            </div>
            <EachBlog>
              <VerticalSpaceBetween
                style={{ width: "100%", alignItems: "flex-start" }}
              >
                <VerticalLeftAlign
                  style={{ overflowY: "hidden" }}
                  onClick={() => handleBlog(each)}
                >
                  <BoldLg>{each?.title}</BoldLg>
                  <RegSm style={{ color: Colors.lightTxt, overflow: "hidden" }}>
                    {each?.description}
                  </RegSm>
                </VerticalLeftAlign>
                <SpaceBetween
                  style={{ marginTop: 10, zIndex: 10, width: "100%" }}
                >
                  <HorizontalAlign>
                    <RegSm>{"Admin "}</RegSm>
                    <RegSmPri style={{ color: Colors.lightTxt }}>
                      - {dayjs(each?.created_at).format("DD MMM YYYY")}
                    </RegSmPri>
                  </HorizontalAlign>
                  {isNewsPage ? (
                    <BoldSm
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDownloadNews(each)}
                    >
                      Download Now
                    </BoldSm>
                  ) : (
                    <></>
                  )}
                </SpaceBetween>
              </VerticalSpaceBetween>
            </EachBlog>
          </EachPopularCourse>
        ))
      ) : (
        <HorizontalAlign style={{ marginTop: 30 }}>
          <RegSmPri>No {heading ?? "News"} to show</RegSmPri>
        </HorizontalAlign>
      )}
    </PopularCourseContent>
  );
};

export default NewsComponent;
